import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ScrollToTop from "./pages/ScrollTop";
import RouteChangeListener from "./components/other/RouteChangeListener";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as pages from "./pages";
import * as layouts from "./layout";
import * as forms from "./components/form";
import { fetchCart } from "./redux/actions/cartActions";
import ProtectedRoute from "./layout/ProtectedRoute";
import NotFound from "./pages/NotFound";

export default function AppRoutes() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isAuthenticated);
  const { bootstrapped } = useSelector((state) => state._persist);

  useEffect(() => {
    if (bootstrapped && isLoggedIn) {
      dispatch(fetchCart());
    }
  }, [bootstrapped, isLoggedIn, dispatch]);

  useEffect(() => {
    if (bootstrapped && !isLoggedIn) {
      navigate("/", { replace: true });
    }
  }, [bootstrapped, isLoggedIn, navigate]);

  return (
    <>
      <ScrollToTop />
      <RouteChangeListener />

      <Routes>
        {/* Public Routes */}
        <Route element={<layouts.LayoutWithHeader />}>
          <Route path="/" element={<pages.LandingPage />} />
          <Route path="/login" element={<pages.Login2 />} />
          <Route
            path="/vendor-registration"
            element={<forms.VendorRegistration />}
          />
          {/* <Route path="/vendor-login" element={<pages.VendorLogin />} /> */}
          <Route path="/vendor-kyc" element={<forms.VendorKyc />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<layouts.CompleteLayout />}>
          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<pages.Home />} />
            <Route path="/vendor-home" element={<pages.VendorHome />} />
          </Route>
          <Route path="/categories/:category" element={<pages.Categories />} />
          <Route path="/wishlist" element={<pages.Wishlist />} />
          <Route path="/profile" element={<pages.Profile />} />
          <Route path="/address" element={<pages.Address />} />
          <Route path="/orders" element={<pages.Orders />} />
          <Route path="/orders/refund" element={<pages.Refund />} />
          <Route path="/orders/track/:orderId" element={<pages.Track />} />
          <Route path="/orders/exchange" element={<pages.ExchangeProduct />} />
          <Route path="/orders/return" element={<pages.ReturnProduct />} />
          <Route path="/payments" element={<pages.PaymentHistory />} />
          <Route path="/notifications" element={<pages.Notifications />} />
          <Route path="/cart" element={<pages.Cart />} />
          <Route path="/checkout" element={<pages.Checkout />} />
          <Route path="/collections/:type" element={<pages.Collections />} />
          <Route path="/about-us" element={<pages.AboutUs />} />
          <Route
            path="/terms-and-conditions"
            element={<pages.TermsAndConditions />}
          />
          <Route path="/privacy-policy" element={<pages.PrivacyPolicy />} />
          <Route
            path="/return-and-refund-policy"
            element={<pages.ReturnAndRefundPolicy />}
          />
          <Route
            path="/ProductsDetails/:pro_id"
            element={<pages.ProductDetail />}
          />
          <Route path="/products" element={<pages.ProductPage />} />
          <Route path="/latest-news" element={<pages.LatestNews />} />
          <Route path="*" element={<pages.Home />} />
        </Route>
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}
